import { render, staticRenderFns } from "./DBDocument.vue?vue&type=template&id=022b8289&scoped=true&"
import script from "./DBDocument.vue?vue&type=script&lang=js&"
export * from "./DBDocument.vue?vue&type=script&lang=js&"
import style0 from "./DBDocument.vue?vue&type=style&index=0&id=022b8289&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022b8289",
  null
  
)

export default component.exports